<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-mb-0 ts-text-xs">{{
          $t('customerMemberCard.customer')
        }}</label>
        <a-select v-model="model.customer_id" :options="customerProfiles" show-search option-filter-prop="children"
          class="ts-w-full" :class="{ 'is-invalid': errors.has('customer_id') }" placeholder="Select"
          disabled></a-select>
        <div class="validate" v-if="errors.has('customer_id')">
          {{ errors.first('customer_id') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-mb-0 ts-text-xs">{{
          $t('customerMemberCard.serialCard')
        }}</label>
        <input v-model.trim="model.serial_card" type="text" class="form-control"
          :class="{ 'is-invalid': errors.has('serial_card') }" style="height: 32px;" disabled />
        <div class="validate" v-if="errors.has('serial_card')">
          {{ errors.first('serial_card') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-mb-0 ts-text-xs">{{
          $t('customerMemberCard.cardType')
        }}</label>
        <a-select v-model="model.card_type_id" :options="cardTypeList" show-search option-filter-prop="children"
          class="ts-w-full" :class="{ 'is-invalid': errors.has('card_type_id') }" placeholder="Select"
          @change="onCardTypeChange"></a-select>
        <div class="validate" v-if="errors.has('card_type_id')">
          {{ errors.first('card_type_id') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-mb-0 ts-text-xs">
          {{ $t('customerMemberCard.maxTime') }}
        </label>
        <input v-model.number="model.max_times" type="number" class="form-control" style="height: 32px;" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-mb-0 ts-text-xs">
          {{ $t('customerMemberCard.status') }}
        </label>
        <a-select v-model="model.status_id" :options="statusList" show-search option-filter-prop="children"
          class="ts-w-full" :class="{ 'is-invalid': errors.has('status_id') }" placeholder="Select"></a-select>
        <div class="validate" v-if="errors.has('status_id')">
          {{ errors.first('status_id') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-mb-0 ts-text-xs">{{
          $t('customerMemberCard.activateDate')
        }}</label>
        <a-date-picker v-model="model.activate_date" class="ts-w-full" show-time format="DD-MM-YYYY HH:mm:ss"
          valueFormat="DD-MM-YYYY HH:mm:ss" :class="{ 'is-invalid': errors.has('activate_date') }"></a-date-picker>
        <div class="validate" v-if="errors.has('activate_date')">
          {{ errors.first('activate_date') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-mb-0 ts-text-xs">{{
          $t('customerMemberCard.expiryDate')
        }}</label>
        <a-date-picker v-model="model.expiry_date" class="ts-w-full" show-time format="DD-MM-YYYY HH:mm:ss"
          valueFormat="DD-MM-YYYY HH:mm:ss" :class="{ 'is-invalid': errors.has('expiry_date') }"></a-date-picker>
        <div class="validate" v-if="errors.has('expiry_date')">
          {{ errors.first('expiry_date') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-mb-0 ts-text-xs">{{
          $t('customerMemberCard.remark')
        }}</label>
        <textarea v-model="model.remark" rows="3" class="form-control" :class="{ 'is-invalid': errors.has('remark') }"
          placeholder="Note something here"></textarea>
        <div class="validate" v-if="errors.has('remark')">
          {{ errors.first('remark') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2 ts-mt-3">
        <ts-button :disabled="loading" @click.prevent="() => $emit('cancel')">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button v-if="isUpdate" color="primary" @click.prevent="onCheckExist" :disabled="loading">
          {{ $t('update') }}
        </ts-button>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>

    <!-- form-action -->
    <a-modal v-if="exist" v-model="exist" centered :header="null" :zIndex="1050" :footer="null" :closable="false"
      width="400px">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="ts-flex ts-items-center ts-gap-3 ts-px-4 ts-pb-3 ts-border-b ts-border-gray-200 ts-w-full">
            <div class="ts-flex-shrink-0">
              <i class="fas fa-exclamation ts-text-orange-500"></i>
            </div>
            <b class="ts-text-sm ts-font-medium ts-text-gray-900">
              Are you sure ?
            </b>
          </div>

          <div class="ts-px-2 ts-pt-2 ts-pb-1 ts-w-full">
            <span class="ts-text-sm ts-text-gray-600">
              This customer is already activated with other serial card. Do you want to overwirte it?
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-mb-0 ts-text-xs">{{
              $t('customerMemberCard.remark')
            }}</label>
            <textarea v-model="model.remark" rows="3" class="form-control"
              :class="{ 'is-invalid': errors.has('remark') }" placeholder="Note something here"></textarea>
            <div class="validate" v-if="errors.has('customer_id')">
              {{ errors.first('customer_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2 ts-mt-3">
            <ts-button :disabled="loading" @click.prevent="() => exist = false">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button :disabled="loading" @click.prevent="onConfirm" outline color="primary">
              {{ $t('confirm') }}
            </ts-button>
          </div>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'customerMemberCardForm',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      exist: false,
      model: {
        customer_member_card_id: null,
        customer_id: null,
        serial_card: null,
        activate_date: moment().format('DD-MM-YYYY HH:mm:ss'),
        expiry_date: null,
        status_id: 1,
        remark: null,
        overwirte: false,
        max_times: null,
        card_type_id: null
      }
    }
  },
  created() {
    this.setEditData()
    this.fetchData()
  },
  computed: {
    ...mapState('customer/customerMemberCard', ['edit_data', 'formViewData']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    },
    customerProfiles() {
      if (this.formViewData.customer && this.formViewData.customer.length) {
        return this.formViewData.customer.map(el => ({
          label:
            'Code: ' +
            el.customer_code +
            ' | Customer: ' +
            el.customer_name +
            ' | Contact: ' +
            el.contact_number +
            ' | Gender: ' +
            el.gender,
          value: el.customer_id
        }))
      }
      return []
    },
    cardTypeList() {
      if (this.formViewData.cardType && this.formViewData.cardType.length) {
        return this.formViewData.cardType.map(el => ({
          label: el.card_types,
          value: el.card_type_id,
          max_times: el.max_times
        }))
      }
      return []
    },
    statusList() {
      return [
        { label: 'Active', value: 1 },
        { label: 'Inactive', value: 2 },
        { label: 'Pending', value: 3 }
      ]
    }
  },
  methods: {
    ...mapActions('customer/customerMemberCard', ['getFormViewData']),
    async fetchData() {
      this.loading = true
      await this.getFormViewData({
        params: undefined,
        index: undefined
      }).finally(() => (this.loading = false))
    },
    async onCheckExist() {
      this.loading = true
      await this.$store
      this.$store
        .dispatch('customer/customerMemberCard/checkExist', this.model)
        .then(response => {
          this.exist = response.exist;
          if (response.exist) {
            this.loading = false
          } else {
            this.onUpdate()
          }
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    onConfirm() {
      this.model.overwirte = true
      this.onUpdate()
    },
    onCardTypeChange(selectedId) {
      const selectedCard = this.cardTypeList.find(c => c.value === selectedId)
      this.model.max_times = selectedCard ? selectedCard.max_times : null
    },
    onUpdate() {
      this.loading = true
      this.$store
        .dispatch('customer/customerMemberCard/update', {
          id: this.model.customer_member_card_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.model.overwirte = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.customer_member_card_id = this.edit_data.customer_member_card_id
        this.model.customer_id = this.edit_data.customer_id
        this.model.serial_card = this.edit_data.serial_card
        this.model.activate_date = this.edit_data.activate_date ? moment(this.edit_data.activate_date, "DD-MM-YYYY hh:mm:ss A").format("DD-MM-YYYY HH:mm:ss") : null
        this.model.expiry_date = this.edit_data.expiry_date ? moment(this.edit_data.expiry_date, "DD-MM-YYYY hh:mm:ss A").format("DD-MM-YYYY HH:mm:ss") : null
        this.model.status_id = this.edit_data.status_id
        this.model.remark = this.edit_data.remark
        this.model.max_times = this.edit_data.max_times
        this.model.card_type_id = this.edit_data.card_type_id
      }
    },
    clearInput() {
      this.model.customer_member_card_id = null
      this.model.customer_id = null
      this.model.serial_card = null
      this.model.activate_date = moment().format('DD-MM-YYYY HH:mm:ss')
      this.model.expiry_date = null
      this.model.status_id = 1
      this.model.remark = null
      this.model.overwirte = false
      this.model.max_times = null
      this.model.card_type_id = null
      this.$store.commit('customer/customerMemberCard/SET_EDIT_DATA', {})
    }
  },
  watch: {
    'model.customer_id'(value) {
      if (!value) {
        this.model.status_id = 3
      } else if (this.model.status_id === 3) {
        this.model.status_id = 1
      }
    }
  }
}
</script>
<style>
.ant-calendar-picker-input {
  height: 32px !important;
}
</style>